import * as React from 'react';
import * as classes from '../payment-gateway-style.scss';
import { Control } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { ToastComponent, ToastType } from '@common/components';
import { FormWrapper } from '@common/components/form-wrapper/form-wrapper.component';
import { toast } from 'react-toastify';
import { ToastOptions } from '@common/components/toast/toast';
import {
  HostedCheckoutTransactionCreateModel,
  HostedCheckoutTransactionType,
  PaymentMethods
} from '@models/HostedCheckoutTransactionViewModel';
import { PaymentPurpose } from '@models/Payment';
import { PaymentTerms, PaymentType } from '@models/Payment';
import { ContractOrderType, ContractBalancesViewModel } from '@models/Contract';
import { config } from '../../../common/config';

export interface HostedCheckoutComponentProperties {
  readonly accountId?: number;
  readonly contractId?: number;
  readonly swoId?: number;
  readonly installmentsFee: number;
  readonly isPreAuthOnly?: boolean;
  readonly multiplePayments?: Array<ContractBalancesViewModel>;
  readonly orderType?: ContractOrderType;
  readonly payInInstallments: boolean;
  readonly paymentAmountBalance: number;
  readonly paymentAmountInitial?: number;
  readonly paymentDate?: Date;
  readonly paymentMethod: PaymentMethods;
  readonly paymentPurpose: PaymentPurpose;
  readonly paymentTerms: PaymentTerms;
  readonly paymentTypeBalance: PaymentType;
  readonly paymentTypeInitial: PaymentType;
  readonly remainingBalance: number;
  readonly remainingBalanceDueString: string;
  readonly totalPrice?: number;
  readonly transactionData?: any;
  readonly usingSavedCard: boolean;
  readonly buildCheckoutRequest: (
    data: HostedCheckoutTransactionCreateModel,
    button: HTMLButtonElement
  ) => Promise<void>;
  readonly getHiddenFormButton?: (button: HTMLButtonElement) => void;
}

export class HostedCheckoutComponent extends React.PureComponent<HostedCheckoutComponentProperties> {
  private button: any;
  constructor(props: HostedCheckoutComponentProperties) {
    super(props);
  }

  getTransactionType = (): HostedCheckoutTransactionType => {
    switch (this.props.paymentPurpose) {
      case PaymentPurpose.Contract:
        return this.props.paymentTerms === PaymentTerms.OneInstallment
          ? HostedCheckoutTransactionType.ContractFullPayment
          : HostedCheckoutTransactionType.ContractInstallmentsPayment;
      case PaymentPurpose.Multiple:
        return HostedCheckoutTransactionType.CombinedPayments;
      case PaymentPurpose.PreAuthorization:
        return (this.props.contractId ? this.props.contractId : 0) > 0 &&
          (this.props.accountId ? this.props.accountId : 0) <= 0
          ? HostedCheckoutTransactionType.UpdateInstallmentsAuthorization
          : HostedCheckoutTransactionType.PreAuthorization;
      case PaymentPurpose.SWO:
        return HostedCheckoutTransactionType.ServiceFeePayment;
      default:
        return HostedCheckoutTransactionType.Undefined;
    }
  };

  clickSubmit: any = () => {
    if (this.props.paymentTypeInitial !== PaymentType.CreditCard || this.props.usingSavedCard) {
      return;
    }
    // do pre-submit (calculate the hash on the backend)
    const button = this.button;
    if (this.props.paymentAmountInitial && this.props.paymentAmountInitial === 0) {
      toast.error(
        <ToastComponent type={ToastType.Error} message={'Payment initial amount must be greater than 0.'} />,
        ToastOptions.Error
      );
      return;
    }
    const request: HostedCheckoutTransactionCreateModel = {
      initialAmount: this.props.paymentAmountInitial !== undefined ? this.props.paymentAmountInitial : 0,
      multiplePayments: this.props.multiplePayments,
      numberOfInstallments: this.props.paymentTerms,
      remainingBalance: this.props.remainingBalance,
      swoId: this.props.swoId,
      type: this.getTransactionType()
    };
    this.props.buildCheckoutRequest(request, button);
  };

  loadButton = (b: any) => {
    this.button = b;
  };

  render() {
    /*let recurringBilling = null;
    if (!this.props.isPreAuthOnly && this.props.paymentTerms !== PaymentTerms.OneInstallment) {
      recurringBilling = (
        <div>
          <Control.text
            model=".x_recurring_billing"
            name="x_recurring_billing"
            hidden={true}
            value={this.props.paymentTerms !== undefined && this.props.paymentTerms > 1 ? 'TRUE' : 'FALSE'}
          />
          <Control.text model=".x_recurring_billing_id" name="x_recurring_billing_id" hidden={true} />
          <Control.text
            model=".x_recurring_billing_amount"
            name="x_recurring_billing_amount"
            hidden={true}
            value={this.props.remainingBalance}
          />
          <Control.text model=".x_recurring_billing_start_date" name="x_recurring_billing_start_date" hidden={true} />
          <Control.text model=".x_recurring_billing_end_date" name="x_recurring_billing_end_date" hidden={true} />
        </div>
      );
    } */

    let hiddenForm = (
      <FormWrapper
        className={classes.hidden}
        action={config.hostedCheckoutPostEndpoint}
        method="post"
        target="iframe_1"
        model={FormNames.HiddenPayeezyTestForm}
        hideNativeErrors={true}
      >
        <Control.text model=".x_login" name="x_login" hidden={true} />
        <Control.text
          model=".x_amount"
          name="x_amount"
          hidden={true}
          value={this.props.isPreAuthOnly ? 0 : this.props.paymentAmountInitial}
        />
        {this.props.isPreAuthOnly && <Control.text model="x_type" value="AUTH_ONLY" />}
        <Control.text model=".x_fp_sequence" name="x_fp_sequence" hidden={true} />
        <Control.text model=".x_fp_timestamp" name="x_fp_timestamp" hidden={true} />
        <Control.text model=".x_fp_hash" name="x_fp_hash" hidden={true} />
        {/* <Control.text model=".Ecommerce_flag" name="Ecommerce_flag" hidden={true} /> */}
        <Control.text model=".x_show_form" name="x_show_form" hidden={true} />
        <Control.text model=".x_relay_response" name="x_relay_response" value="TRUE" hidden={true} />
        <Control.text model=".x_currency_code" name="x_currency_code" hidden={true} />

        <Control.text model=".x_po_num" name="x_po_num" hidden={true} />
        <Control.text model=".x_reference_3" name="x_reference_3" hidden={true} />
        <Control.text model=".x_invoice_num" name="x_invoice_num" hidden={true} />
        <Control.text model=".x_cust_id" name="x_cust_id" hidden={true} />
        <Control.text
          model=".merchant_cookie_1"
          name="merchant_cookie_1"
          hidden={true}
          value={this.props.paymentTerms}
        />
        {/* recurringBilling */}
        <button ref={this.loadButton} type="submit" className="btn btn-hidden">
          Real checkout
        </button>
      </FormWrapper>
    );
    return (
      <div className="container light-gray-bc">
        <div className="row">{hiddenForm}</div>
        <div className="row end-xs">
          <div className="col-xs-12">
            <button
              ref={this.props.getHiddenFormButton}
              onClick={this.clickSubmit}
              type="button"
              className="btn btn-hidden"
            >
              Checkout
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payment/_components/gateway/hosted-checkout.component.tsx